import { render } from "./Dashboard.vue?vue&type=template&id=1f0078e0&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=1f0078e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1f0078e0"

export default script